import {Component, OnInit} from '@angular/core';
import {BaseHttpService} from '../../../../services/base-http/base-http.service';
import {TranslatableString} from '../../../../models/TranslatableString';
import {Article} from '../../../../models/Article';

@Component({
  selector: 'app-team-info',
  templateUrl: './team-info.component.html',
  styleUrls: ['./team-info.component.scss']
})
export class TeamInfoComponent {
  
  article: Article;
  
  constructor(private httpService: BaseHttpService) {
    this.httpService.getArticle('team').subscribe((data) => {
      this.article = new Article();
      this.article.header = new TranslatableString(data[0].header, data[0].header_en, data[0].header_bg, data[0].header_ru);
      this.article.content = new TranslatableString(data[0].article, data[0].article_en, data[0].article_bg, data[0].article_ru);
    });
  }
}
